import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

// prettier-ignore
const SolicitudPremio = () => import('@/entities/reniecytMs/solicitudes/solicitud-premio/solicitud-premio.vue');
const SolicitudPremio2026 = () => import('@/entities/reniecytMs/solicitudes/solicitud-premio-2026/solicitud-premio-2026.vue');
const SeleccionaRol = () => import('@/entities/reniecytMs/selecciona-rol/selecciona-rol.vue');
const Postulador = () => import('@/entities/reniecytMs/postulador/postulador.vue');
const ConsultaRegistrosAdmin = () => import('@/entities/reniecytMs/solicitudes/consulta-registros-admin/consulta-registros-admin.vue');
const AsignacionEvaluadores = () => import('@/entities/reniecytMs/asignacion-evaluadores/asignacion-evaluadores.vue');
const GestionUsuarios = () => import('@/entities/reniecytMs/gestion-usuarios/premios-gestion-usuarios.vue');
const EvaluacionIndividual = () => import('@/entities/reniecytMs/evaluaciones/individual/individual.vue');
const DatosEvaluacionIndividual = () =>
  import('@/entities/reniecytMs/evaluaciones/individual/datos-evaluacion-individual/datos-evaluacion-individual.vue');
const DatosEvaluacionIndividual2026 = () =>
  import('@/entities/reniecytMs/evaluaciones/individual/datos-evaluacion-individual-2026/datos-evaluacion-individual-2026.vue');
const EvaluacionPlenaria = () => import('@/entities/reniecytMs/evaluaciones/plenaria/plenaria.vue');
const DatosEvaluacionPlenaria = () =>
  import('@/entities/reniecytMs/evaluaciones/plenaria/datos-evaluacion-plenaria/datos-evaluacion-plenaria.vue');
const DatosEvaluacionPlenaria2026 = () =>
  import('@/entities/reniecytMs/evaluaciones/plenaria/datos-evaluacion-plenaria-2026/datos-evaluacion-plenaria-2026.vue');
const ConstanciasEvaluador = () => import('@/entities/reniecytMs/constancias-evaluador/constancias-evaluador.vue');
const constancias = () => import('@/entities/reniecytMs/constancias/constancias.vue');

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: '/solicitud/postulador/',
      name: 'Postulador',
      component: Postulador,
      meta: { authorities: [Authority.EXTERNAL_USER] },
    },
    {
      path: '/selecciona-rol',
      name: 'SeleccionaRol',
      component: SeleccionaRol,
    },
    {
      path: '/consulta-registros-admin',
      name: 'ConsultaRegistrosAdmin',
      component: ConsultaRegistrosAdmin,
      meta: {
        authorities: [Authority.ADMIN_PREMIOS, Authority.COORDINADOR, Authority.VALIDADOR_DOCUMENTAL, Authority.CONSULTA],
      },
    },
    {
      path: '/premios-gestion-usuarios',
      name: 'GestionUsuarios',
      component: GestionUsuarios,
      meta: {
        authorities: [Authority.ADMIN_PREMIOS, Authority.COORDINADOR],
      },
    },
    {
      path: '/solicitud/premio',
      name: 'SolicitudPremio',
      component: SolicitudPremio,
    },
    {
      path: '/solicitud/premio-2026',
      name: 'SolicitudPremio2026',
      component: SolicitudPremio2026,
    },
    {
      path: '/evaluacion/individual',
      name: 'EvaluacionIndividual',
      component: EvaluacionIndividual,
      meta: {
        authorities: [Authority.EVALUADOR_INDIVIDUAL, Authority.PRESIDENTE_COMISION],
      },
    },
    {
      path: '/evaluacion/individual/datos-evaluacion-individual/:idSolicitud',
      name: 'DatosEvaluacionIndividual',
      component: DatosEvaluacionIndividual,
      meta: {
        authorities: [Authority.EVALUADOR_INDIVIDUAL, Authority.PRESIDENTE_COMISION],
      },
    },
    {
      path: '/evaluacion/individual/datos-evaluacion-individual-2026/:idSolicitud',
      name: 'DatosEvaluacionIndividual2026',
      component: DatosEvaluacionIndividual2026,
      meta: {
        authorities: [Authority.EVALUADOR_INDIVIDUAL, Authority.PRESIDENTE_COMISION],
      },
    },
    {
      path: '/Evaluacion/plenaria',
      name: 'EvaluacionPlenaria',
      component: EvaluacionPlenaria,
      meta: {
        authorities: [Authority.EVALUADOR_PLENARIA, Authority.PRESIDENTE_COMISION, Authority.COORDINADOR, Authority.ADMIN_PREMIOS],
      },
    },
    {
      path: '/evaluacion/plenaria/datos-evaluacion-plenaria/:idEvaluacionPlenaria',
      name: 'DatosEvaluacionPlenaria',
      component: DatosEvaluacionPlenaria,
      meta: {
        authorities: [Authority.EVALUADOR_PLENARIA, Authority.PRESIDENTE_COMISION, Authority.COORDINADOR, Authority.ADMIN_PREMIOS],
      },
    },
    {
      path: '/evaluacion/plenaria/datos-evaluacion-plenaria-2026/:idEvaluacionPlenaria',
      name: 'DatosEvaluacionPlenaria2026',
      component: DatosEvaluacionPlenaria2026,
      meta: {
        authorities: [Authority.EVALUADOR_PLENARIA, Authority.PRESIDENTE_COMISION, Authority.COORDINADOR, Authority.ADMIN_PREMIOS],
      },
    },
    {
      path: '/asignacion-evaluadores',
      name: 'AsignacionEvaluadores',
      component: AsignacionEvaluadores,
      meta: {
        authorities: [Authority.ADMIN_PREMIOS, Authority.COORDINADOR],
      },
    },
    {
      path: '/constancias',
      name: 'constancias',
      component: constancias,
      meta: {
        authorities: [Authority.ADMIN_PREMIOS, Authority.COORDINADOR],
      },
    },
    {
      path: '/constancias-evaluador',
      name: 'ConstanciasEvaluador',
      component: ConstanciasEvaluador,
      meta: {},
    },
  ],
};
